module.exports = __webpack_public_path__ + "img/icon.e97925ec.png";